/** Fechamento completo da ferramenta em ~0,62 s de relógio de parede. */
export const VELOCIDADE_ACIONAMENTO = 1.6

/**
 * Progresso do acionamento em função do tempo decorrido desde o início do
 * gesto, e não da soma dos quadros desenhados.
 *
 * A versão anterior somava `dt` de cada quadro limitado a 0,1 s. O limite
 * existia para um quadro perdido não concluir a ação sozinho, mas amarrava a
 * duração do gesto à taxa de quadros: numa cena a 5 quadros por segundo,
 * segurar um segundo avançava 0,08 em vez de 0,32, e em máquina sem GPU ou
 * celular a ferramenta nunca terminava de fechar — segurar o marcador não
 * cortava nada. Aqui o tempo decorrido é a única medida, e o alvo continua
 * sendo o teto: um intervalo longo chega ao alvo, nunca passa dele.
 */
export function progressoAcionamento(inicial: number, alvo: number, segundos: number): number {
  const percorrido = Math.max(0, segundos) * VELOCIDADE_ACIONAMENTO
  return alvo > inicial
    ? Math.min(alvo, inicial + percorrido)
    : Math.max(alvo, inicial - percorrido)
}
